export default "__VITE_ASSET__304dd335__"